<template>
  <div class="article-list-id-warp">

  	<y-teacher-info></y-teacher-info>

  	<y-nav></y-nav>

    <div class="content_detail main">
      <!--room下的藏金阁和文章的列表修改-->
      <div class="cjg_item_wrap yf-text_12">
      	<div class="user_change">
          <span v-for="(title, index) of options" @click="push(index)" :key="index" :class="{ checkborder: t === index }">{{ title }}</span>
        </div>
      	<div class="item_wrap">
  			  <div class="item clearfix" v-for="item in list" :key="item.id">
  			  	<div class="item_left left">
  			  		<img :src="item.userAvatar" :alt="item.userName" />
  			  	</div>
  			  	<div class="item_right left">
  			  		<p class="title_wrap">
  			  			<nuxt-link :to="`/article/detail/${item.id}`" >
  			  				<span class="cjgflag" v-if="item.type === 1">CJG</span>{{ item.userName }} - {{ item.title }}
  			  			  <span v-if="item.gcoins" class="jingbi">
                    <i class="iconfont icon-jinbi"></i>
                  </span>
                  <template v-if="item.gcoins && t !== 2">
                    <img v-if="item.isBuy" src="~assets/list-7.jpg" :alt="item.title" />
                    <img v-else-if="!item.isBuy && !isTheTeacher" src="~assets/list-5.png" :alt="item.title" />
                    <span class="order" v-if="item.status === 4 || (item.type === 2 && item.status === 2)">服务已结束 <i></i></span>
                  </template>
  			  		  </nuxt-link>
  			  		</p>
  			  		<p class="info_wrap ellipsis">{{ item.desc }}</p>
  			  		<p class="time_wrap_cjg" v-if="item.type === 1">
  			  			<span>订阅时间：{{ item.createAt }}至{{ item.stopTime }}</span>
  			  			<span>服务时间：{{ item.createAt }}至{{ item.endTime }}</span>
  			  		</p>
  			  		<p class="time_wrap_wenzhang" v-else>
  			  			<span>{{ item.createAt }}</span>
  			  			<span class="right">{{ item.viewCount }}人阅读</span>
  			  		</p>
  			  	</div>
  			  </div>
      	</div>
        <y-pager :total="total"></y-pager>
      </div>
    </div>
  </div>
</template>

<script>
import Dialog from '@/utils/Dialog'
import YTeacherInfo from '@/components/TeacherInfo'
import YNav from '@/components/Nav'

export default {
  name: 'article-list',
  scrollToTop: true,
  watchQuery: ['page', 'num', 't'],
  validate ({ params, query }) {
    return params.id > 0 && (query.t === undefined || query.t < 3)
  },
  async asyncData ({ store, error, query, params, $axios }) {
    // 识别t是否有效，无效返回404
    let t = query.t ? +query.t : 0
    // 初始化老师数据
    let teacher = await store.dispatch('teacher/getInfo', params.id)

    if (teacher.error === 5) {
      error({ statusCode: 404, message: '该页面不存在' })
      return
    }

    let apiUrl, apiParams = {
      page: query.page || 1,
      num: query.num || process.env.DEFAULT_PAGE_SIZE,
      teacher: +params.id
    }
    if (store.getters['user/isTeacher']) {
      // 老师身份
      if (t === 1) {
        // 服务中
        apiParams.service = 1
        apiParams.order = 'teacher'
      } else if (store.state.user.data && teacher.id !== store.state.user.data.id) {
        apiParams.service = 1
      } 
      apiUrl = '/Article/List'
    } else {
      // 用户身份
      switch (t) {
        case 1:
          apiParams.service = 1
          apiParams.pay = 1
          apiUrl = '/Article/List'
          break
        case 2:
          if (store.state.user.data) {
            apiUrl = '/Article/MyList'
          }
          break
        default:
          apiParams.service = 1
          apiParams.order = 'teacher'
          apiUrl = '/Article/List'
      }
    }

    let { list, totalCount } = await $axios._get(apiUrl, apiParams)

    if (t === 1 && (teacher.id !== store.state.user.data.id)) {
      list = list.filter(_ => _.isBuy !== 1)
    }
    
    return {
      t,
      list,
      total: totalCount
    }
  },
  head () {
    if (this.$store.state.teacher.data) {
      return {
        title: this.$store.state.teacher.data.userName + '-文章-一富财经—打造中国最靠谱的的投资者教育平台,股市直播,股票交流'
      }
    }
  },
  methods: {
    push (i) {
      this.t = i
      this.$router.push({
        query: {
          t: i ? i : undefined
        }
      })
    }
  },
  computed: {
    authUser () {
      return this.$store.state.user.data
    },
    teacher () {
      return this.$store.state.teacher.data
    },
    isTheTeacher () {
      return this.authUser && this.authUser.id === this.teacher.id
    },
    options () {
      const a = ['全部', '服务中']
      const b = ['全部', '可订阅']
      this.authUser && b.push('已订阅')
      return this.isTheTeacher ? a : b
    }
  },
  components: {
  	YTeacherInfo,
    YNav
  }
}
</script>
